<template>
  <div>
    <h4 v-if="!sm" style="margin-top: 10px; margin-bottom: 10px">
      {{ titulo }}
    </h4>
    <div v-if="!sm">
      <collapse-bar
        style="margin-bottom: 5px"
        :visualizar="visualizar"
        :sm="sm"
        :pergunta="pergunta[n - 1]"
        :nome-membros="nomeMembros"
        :fotos-membros="fotosMembros"
        :notas-recebidas="notasRecebidas[pergunta[n - 1]]"
        v-for="n in quantidade"
        :key="n"
        :quantidade="quantidadeLinhas"
        :notas-dadas="notasDadas[n - 1]"
        :posicao="n - 1"
        :titulo="titulo"
        :auto-avaliacao="autoAvaliacao"
      />
    </div>
    <div v-if="sm">
      <collapse-bar
        style="margin-bottom: 5px"
        :visualizar="visualizar"
        :sm="sm"
        :pergunta="pergunta[n - 1]"
        :nome-membros="nomeMembros"
        :fotos-membros="fotosMembros"
        :notas-recebidas="notasGerais[n - 1]"
        v-for="n in quantidade"
        :key="n"
        :quantidade="quantidadeLinhas"
        :notas-dadas="notasDadas[n - 1]"
        :posicao="n - 1"
        :titulo="titulo"
      />
    </div>
  </div>
</template>

<script>
import CollapseBar from '@/components/CollapseBar.vue';

export default {
  props: {
    quantidadeLinhas: {
      type: Number,
      required: false,
      default: () => 0,
    },
    notasRecebidas: {
      type: Array,
      required: false,
      default: () => [],
    },
    notasRecebidasObjeto: {
      type: Object,
      required: false,
      default: () => {},
    },
    visualizar: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    sm: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    titulo: {
      type: String,
      required: true,
    },
    pergunta: {
      type: Array,
      required: true,
    },
    quantidade: {
      type: Number,
      required: true,
    },
    posicao: {
      type: Number,
      required: false,
      default: () => 0,
    },
    nomeMembros: {
      type: Array,
      required: false,
      default: () => [],
    },
    fotosMembros: {
      type: Array,
      required: false,
      default: () => [],
    },
    notasDadas: {
      type: Array,
      required: false,
      default: () => [],
    },
    autoAvaliacao: {
      type: Number,
      required: false,
      default: () => 0,
    },
  },
  components: {
    CollapseBar,
  },
  created() {
    console.log(this.autoAvaliacao);
    this.notasDadasEnvia = this.notasDadas;
    if (this.sm) {
      for (var i = 0; i < this.pergunta.length; i++) {
        const arrayZeros = Array.from(
          { length: this.nomeMembros.length },
          () => 0,
        );
        this.notasGerais.push(arrayZeros);
        for (var j = 0; j < this.nomeMembros.length; j++) {
          if (
            this.nomeMembros[j] in this.notasRecebidasObjeto[this.pergunta[i]]
          ) {
            this.notasGerais[i][j] =
              this.notasRecebidasObjeto[this.pergunta[i]][this.nomeMembros[j]];
          }
        }
      }
    }
  },
  data: () => ({
    notasDadasEnvia: null,
    notasGerais: [],
  }),
};
</script>
